import Error from '../model/Error';
import axios from 'axios';

export default class ClubSalesListExportRepository {
    static getCsvByClubIdAndQuery(clubId, query) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/sales-list/export/csv${query}`, { responseType: 'blob' })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const headerLine = response.headers['content-disposition'];
                    const startFileNameIndex = headerLine.indexOf('"') + 1;
                    const endFileNameIndex = headerLine.lastIndexOf('"');
                    const filename = headerLine.substring(startFileNameIndex, endFileNameIndex);
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    resolve();
                })
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
